import React from "react";
import ListItem from "./ListItem";
import "./list.css";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";

const List = ({ list }) => (
  <div>
    <div className="list-wrap">
      {list.map((item) => (
        <ListItem key={item.id} item={item} />
      ))}
    </div>
    <Stack>
      <Pagination count={5} color="primary" className="pagination" />
    </Stack>
  </div>
);

export default List;
